"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dotsIdentifier = ({ ast, execObject }) => {
    const identifier = ast.children.DotsIdentifier[0].children.identifier;
    if (identifier.length === 1) {
        return execObject.manager.variable.reference(identifier[0].image);
    }
    else {
    }
};
